import React, { useState } from 'react';
import { connect } from 'react-redux';
import SettingsContainer from '../components/settings/SettingsContainer';
import SettingsSidebar from '../components/settings/SettingsSidebar';
import { isAdminRole } from '../utils/roleHelpers';

const Settings = ({ user }) => {
  const [activeTab, setActiveTab] = useState('Admin Settings');
  const isAdmin = isAdminRole(user?.role);

  return (
    <div className="min-h-screen bg-gray-50 py-4 px-2 sm:py-8 sm:px-4 pb-20 md:pb-4">
      <div className="mx-auto bg-white rounded-lg shadow-sm flex flex-col md:flex-row overflow-hidden">
        <SettingsSidebar
          activeTab={activeTab}
          onTabChange={setActiveTab}
          isAdmin={isAdmin}
          isPlatformAdmin={user?.role === 'platform_admin'}
        />
        <div className="flex-1 border-t md:border-t-0 md:border-l border-gray-200 overflow-x-auto">
          <SettingsContainer initialTab={activeTab} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user
});

export default connect(mapStateToProps)(Settings);
